export type EditableItem = {
    id: string,
    label: string,
    hasRules: boolean,
    href?: string,
    hideSettings?: boolean,
    isDefault?: boolean,
}

export enum EditableSortableType {
    Collection = "Collection",
    AboutPages = "AboutPages"
}
